module.exports = __webpack_public_path__ + "img/image_27.c98f64e3.png";